import { useEffect, useState } from "react";

const navLinks = [
  { href: "#hot", label: "实时热榜" },
  { href: "#category", label: "现场分类" },
  { href: "#feed", label: "前排围观" },
  { href: "#guide", label: "吃瓜指南" },
  { href: "#faq", label: "常见问题" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/90 backdrop-blur-md shadow-[0_1px_0_0_oklch(var(--primary-200)/0.5)]"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 items-center justify-between px-4 md:px-8">
        <a
          href="#top"
          className="group flex items-center gap-2 whitespace-nowrap"
          aria-label="爆炸瓜首页"
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
            <i className="ri-vidicon-2-fill text-lg" aria-hidden="true"></i>
          </span>
          <span
            className={`font-display text-2xl transition-colors ${
              scrolled ? "text-primary-700" : "text-white"
            }`}
          >
            爆炸瓜
          </span>
        </a>

        <ul className="hidden items-center gap-1 md:flex">
          {navLinks.map((l) => (
            <li key={l.href}>
              <a
                href={l.href}
                className={`rounded-full px-4 py-2 text-sm font-medium whitespace-nowrap transition-colors ${
                  scrolled
                    ? "text-foreground-700 hover:bg-secondary-200/60 hover:text-primary-700"
                    : "text-white/90 hover:bg-white/15"
                }`}
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-2">
          <a
            href="#feed"
            className="hidden items-center gap-1 rounded-full bg-primary-500 px-5 py-2 text-sm font-semibold text-background-50 whitespace-nowrap transition hover:bg-primary-600 sm:inline-flex"
          >
            在线吃瓜
            <i className="ri-arrow-right-up-line" aria-hidden="true"></i>
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label={open ? "关闭菜单" : "打开菜单"}
            className={`inline-flex h-10 w-10 items-center justify-center rounded-lg md:hidden ${
              scrolled
                ? "text-primary-700 hover:bg-secondary-200/60"
                : "text-white hover:bg-white/15"
            }`}
          >
            <i className={`text-xl ${open ? "ri-close-line" : "ri-menu-line"}`} aria-hidden="true"></i>
          </button>
        </div>
      </nav>

      {open && (
        <div className="mx-3 mb-3 rounded-2xl border border-secondary-200 bg-background-50 p-2 md:hidden">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="block rounded-xl px-4 py-3 text-sm font-medium text-foreground-700 hover:bg-secondary-200/60 hover:text-primary-700"
            >
              {l.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
}